<div [formGroup]="formGroup" class="flex flex-col w-full" *transloco="let t">
  <mat-form-field [appearance]="appearance" class="fuse-mat-dense flex-auto" [subscriptSizing]="subscriptSizing">
    @if (label) {
      <mat-label>{{ t(label) | capitalize }}</mat-label>
    }

    <input
      matInput
      [matTimepicker]="timePicker"
      [matTimepickerMin]="min"
      [matTimepickerMax]="max"
      [name]="controlName"
      [placeholder]="placeholder"
      [formControlName]="controlName"
      [readonly]="disableManualInput"
      (focus)="disableManualInput ? timePicker.open() : ''"
      (click)="disableManualInput ? timePicker.open() : ''"
    />

    <mat-timepicker-toggle matSuffix [for]="timePicker" tabindex="-1"></mat-timepicker-toggle>

    <!-- `interval` é anulado quando há lista: o Material lança "Cannot specify both the `options` and
         `interval` inputs at the same time" se os dois chegarem não-nulos. -->
    <mat-timepicker [interval]="options ? null : interval" [options]="options ?? null" #timePicker></mat-timepicker>

    @if (formControl?.errors ?? {} | firstErrorMessage: formControl : errorMessages; as errorMessage) {
      <mat-error>{{ t(errorMessage) | capitalize }}</mat-error>
    }
  </mat-form-field>
</div>
